import { TaskNotificationBodyAssignedTitle } from "./TaskNotificationBodyAssignedTitle";
import { TaskNotificationBodyProduct } from "./TaskNotificationBodyProduct";
import { TaskNotificationBodyTitleAndDescription } from "./TaskNotificationBodyTitleAndDescription";
import { TaskNotificationBodyAssignedProduct } from "./TaskNotificationBodyAssignedProduct";
import { ComponentNotificationBody } from "./types/task-notification.types";

interface TaskNotificationBodyProps {
  component: ComponentNotificationBody;
  read: boolean;
}
export const TaskNotificationBody = ({
  component,
  read,
}: TaskNotificationBodyProps) => {
  const { type } = component;
  switch (type) {
    case "notification-body-title-and-description":
      return (
        <TaskNotificationBodyTitleAndDescription {...component} read={read} />
      );
    case "notification-body-product":
      return <TaskNotificationBodyProduct {...component} read={read} />;
    case "notification-body-assigned-title":
      return <TaskNotificationBodyAssignedTitle {...component} read={read} />;
    case "notification-body-assigned-product":
      return <TaskNotificationBodyAssignedProduct {...component} read={read} />;
  }
};
